<template>
  <div class="home">
    <!-- 标语 -->
    <div
      class="slogan container"
      v-if="bodyContent.position0&&bodyContent.position0.infoData.length > 0"
      @click="
        detailHandle(
          bodyContent.position0.infoData[0]['strId'],
          bodyContent.position0.infoData[0]['strUrlType'],
          bodyContent.position0.infoData[0]['strUrl']
        )
      "
    >
      <div v-if="bodyContent.position0.infoData.length > 0">
        <h2>{{ bodyContent.position0.infoData[0]["strMasTitle"] }}</h2>
      </div>
      <div v-else class="no-content">暂无数据</div>
    </div>

    <div class="top container" :class="{ flex: !isSpecial }" v-if="bodyContent.position1&&bodyContent.position1.infoData.length > 0">
      <!-- Swiper -->
      <Swiper
        v-if="bodyContent.position1&&bodyContent.position1.infoData.length > 0"
        :isSpecial="isSpecial"
        :swiperArr="bodyContent.position1.infoData"
      ></Swiper>
      <!-- 右侧图片 -->
      <div class="row news" v-if="bodyContent.position2&&bodyContent.position2.infoData && !isSpecial">
        <div class="title">
          <span>{{ bodyContent.position2.strName }}</span>
          <!-- <img src="../assets/images/line.png" alt=""> -->
          <i @click="navHandle(bodyContent.position2.strId)">
            <img
              src="../assets/images/arrow.png"
              alt=""
              style="width: 20px; height: 20px"
            />
          </i>
        </div>
        <ul v-if="bodyContent.position2.infoData.length > 0">
          <li
            v-for="(item, index) in bodyContent.position2.infoData"
            :key="index"
          >
            <span></span>
            <div
              @click="detailHandle(item.strId, item.strUrlType, item.strUrl)"
            >
              {{ item.strMasTitle }}
            </div>
          </li>
        </ul>
        <div v-else class="no-content">暂无数据</div>
      </div>
    </div>
    <div
      class="top container"
      :class="{ flex: !isSpecial }"
      v-for="(v, index) in newList"
      :key="v.id"
      :style="{ marginTop: [index === 0 ? '50px' : '0px'] }"
    >
      <!-- 右侧图片 -->
      <div
        class="row news"
        style="margin-left: 0; padding-right: 0"
        v-for="(vv, index) in v.children"
        :key="index"
      >
        <div :style="{ paddingLeft: [index === 0 ? '0px' : '30px'] }">
          <div class="title">
            <span>{{ vv.strName }}</span>
            <!-- 点击更多 -->
            <i @click="navHandle(vv['strId'])">
              <img
                src="../assets/images/arrow.png"
                alt=""
                style="width: 20px; height: 20px"
              />
            </i>
          </div>
          <ul v-if="vv['infoData'].length > 0">
            <li v-for="(item, index) in vv['infoData']" :key="index">
              <span style="background-color: rgb(220, 220, 220)"></span>
              <div
                style="color: #333"
                @click="detailHandle(item.strId, item.strUrlType, item.strUrl)"
              >
                {{ item.strMasTitle }}
              </div>
            </li>
          </ul>
          <div v-else class="no-content">暂无数据</div>
        </div>
      </div>
    </div>
    <div class="border-10"></div>
    <!-- 友情链接 -->
    <div class="links container">
      <div class="tit"></div>
      <ul class="flex flex-y-center" v-if="navigationForZxArr.length > 0">
        <li v-for="(item, index) in navigationForZxArr" :key="index">
          <img @click="linkHandle(item)" :src="item.strPicPath" alt="" />
        </li>
      </ul>
      <div v-else class="no-content">暂无数据</div>
    </div>

    <div
      class="unit-links container"
      v-if="!!selectData && selectData.length > 0"
    >
      <ul>
        <li v-for="(item, index) in selectData" :key="index">
          <div class="select-menu">
            <a-dropdown>
              <a-menu slot="overlay" @click="handleMenuClick">
                <a-menu-item
                  v-for="item2 in item.children"
                  :key="JSON.stringify(item2)"
                >
                  {{ item2.strName }}
                </a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px">
                <a-icon type="down" />
                {{ item.strName }}
              </a-button>
            </a-dropdown>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Swiper from '@/components/base/swiper.vue'
import "swiper/css/swiper.min.css";
import { infoData, navigationForZx, getLinks,homeData,bodyData } from "@/api/configuration";
import { get } from "../utils/helpers";
export default {
  name: "Home",
  components: {
    Swiper
  },
  data () {
    return {
      bodyContent:{},
      photoWidth: "", // 精彩图片宽度
      calleft: 0, // 精彩图片左移尺寸
      webPositionData: [], // 中间内容列表
      navigationForZxArr: [], // 友情链接数据
      isSpecial: false,
      strColumnStyle:2,//默认一行展示几个
      selectData: [],
      newList:[],
      topNew:[],
      // borderShow: localStorage.getItem('borderShow'),
      list: [
        {
          name: '111'
        },
        {
          name: '222'
        }
      ]
    };
  },
  props: {},
  computed: {},
  created () {
    // localStorage.setItem('borderShow', 'true')
    //this.isSpecial = this.$route.query.strWebSiteId === 'b4a5ad6f2ad74fe6a2310d313bba36b7' || this.$route.query.strWebSiteId === '4b4dc894e2894d4c966c03db2669de03'
    this.getInfoData(); // 获取首页数据
    // this.getNavigationForZx(); // 获取友情链接数据
    this.getLinks()

  },
  mounted () { },
  methods: {
    // 跳外链
    handleMenuClick (e) {
      if (!JSON.parse(e.key).strUrl) {
        return
      }
      window.open(JSON.parse(e.key).strUrl, "_blank");
    },

    getLinks () {
      var param = {}
      getLinks(param)
        .then(res => {

          this.selectData = get(["data", "links"], res.data)
          this.navigationForZxArr = get(["data", "linksPic"], res.data)

        })
        .catch(err => {
          this.$message.destroy();
          console.log(err)
        })
    },
    async getInfoData() {
      let that = this
      let strWebSiteId = this.$route.query.strWebSiteId
      homeData({
        strWebSiteId: strWebSiteId
      })
        .then((res) => {
          let data = get(['data'], res.data).webPositionData
          document.title = get(['data', 'strName'], res.data);
          this.strColumnStyle = parseFloat(get(["data", "strColumnStyle"], res.data));
          let spliceData = data.splice(0,3)
          spliceData.forEach(async (v, k) => {
            let curObj = spliceData[k]
            await bodyData({
              strColId: curObj.strColId,
              strColName: curObj.strColName,
              strType: curObj.strType,
              intCount: curObj.intCount
            })
              .then((res) => {
                const resData = get(['data'], res.data)
                this.webPositionData.push(resData)
                that.$set(
                  that.bodyContent,
                  'position' + (k),
                  get(['data'], res.data)
                )
              })
              .catch((err) => {
                that.$message.destroy()
                that.$message.error(err)
              })
          })
          that.getAllData(data)
        })
        .catch((err) => {
          this.$message.destroy()
          this.$message.error(err)
        })
        
    },
    getAllData(data) {
      const getrom = async (curObj) => {
        const data = await bodyData({
          strColId: curObj.strColId,
          strColName: curObj.strColName,
          strType: curObj.strType,
          intCount: curObj.intCount
        })
        return data.data.data
      }
      this.getPromiseData(data, getrom)
    },
    getPromiseData(data, fun){
      let roomalls = []
      data.forEach((v, k) => {
        roomalls.push(fun(v))
      })
      Promise.all(roomalls).then((res) => {
       this.webPositionData.push(...res)
          const listNumber = Math.ceil(res.length/this.strColumnStyle)
          const dealListData = []
          for(let i=0;i<listNumber;i++){
             let obj = {}
            obj.children = res.splice(0,this.strColumnStyle)
            obj.id = i
            dealListData.push(obj)
          }
          this.newList = dealListData
      })
    },
    //获取首页数据
    // getInfoData () {
    //   infoData({ strWebSiteId: this.$store.state.strWebSiteId })
    //     .then((res) => {
    //       this.topNew = [get(["data", "webPositionData"], res.data)[0]]
    //       this.strColumnStyle = parseFloat(get(["data", "strColumnStyle"], res.data));
    //       this.webPositionData = get(["data", "webPositionData"], res.data);
    //       const allData = get(["data", "webPositionData"], res.data);
    //       document.title = get(["data", "strName"], res.data);
    //       const listData = allData.splice(3,allData.length)
    //       const listNumber = Math.ceil(listData.length/this.strColumnStyle)
    //       const dealListData = []
    //       for(let i=0;i<listNumber;i++){
    //          let obj = {}
    //         obj.children = listData.splice(0,this.strColumnStyle)
    //         obj.id = i
    //         dealListData.push(obj)
    //       }
    //       this.newList = dealListData
    //       // 精彩图片设置滚动
    //       if (res.data.data.webPositionData[5] && res.data.data.webPositionData[5]["infoData"]) {
    //         this.photoWidth = 290 * Number(res.data.data.webPositionData[5]["infoData"].length) * 2;
    //         this.move();
    //       }
    //     })
    //     .catch((err) => {
    //       this.$message.destroy();
    //       this.$message.error(err);
    //     });
    // },

    //获取友情链接数据
    getNavigationForZx () {
      navigationForZx({ strWebSiteId: this.$store.state.strWebSiteId })
        .then((res) => {
          this.navigationForZxArr = get(["data"], res.data);
        })
        .catch((err) => {
          this.$message.destroy();
          this.$message.error(err);
        });
    },

    //移动
    move () {
      this.timer = setInterval(this.starmove, 20);
    },

    //开始移动
    starmove () {
      this.calleft -= 0.6;
      let lengthVal = this.webPositionData[5]["infoData"].length;
      if (this.calleft <= -(290 * Number(lengthVal))) {
        this.calleft = 0;
      }
    },

    //鼠标悬停时停止移动
    stopmove () {
      clearInterval(this.timer);
    },

    // 更多菜单跳转
    navHandle (strId) {
      let routeData = this.$router.resolve({
        path: "/list",
        query: { strWebSiteId: this.$route.query.strWebSiteId, strId: strId },
      });
      window.open(routeData.href, "_blank");
    },

    // 跳转详情
    detailHandle (strId, strUrlType, url) {
      if (strUrlType == '_self') {


        let routeData = this.$router.resolve({
          path: "/detail",
          query: { strWebSiteId: this.$route.query.strWebSiteId, strId: strId },
        });
        window.open(routeData.href, '_self');
      } else {
        window.open(url, '_blank');
      }
    },

    // 友情链接
    linkHandle (item) {
      if (!item.strUrl) {
        return
      }
      window.open(item.strUrl, '_blank'); //跳转至新页面
    },
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ant-dropdown,
.ant-dropdown-menu {
  height: 300px !important;
  overflow-y: auto !important;
}
.home {
  // background: url('../assets/images/bg1.png') no-repeat center top,
  //   url('../assets/images/bg2.png') no-repeat center bottom;

  padding: 0 0 40px;

  .border-10 {
    border-bottom: 10px solid #4051a1;
    margin: 60px 0 30px;
  }
  .unit-links {
    li {
      float: left;
      width: 25%;
      padding-right: 15px;
      margin-bottom: 10px;
      &:nth-child(4n) {
        padding-right: 0 !important;
      }
      .ant-btn {
        margin-left: 0 !important;
        height: 40px;
        line-height: 40px;
      }
      .anticon-down {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
      }
      .select-menu {
        width: 100%;
        .ant-btn {
          width: 100%;
        }
      }
    }
  }
  .container {
    width: 1280px;
    margin: 0 auto;
  }
  .no-content {
    box-sizing: border-box;
    font-size: 18px;
    text-align: center;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slogan {
    box-sizing: border-box;
    padding: 20px 15px 20px;
    background-color: rgb(224, 241, 254);
    margin: 30px auto;
    cursor: pointer;
    h2 {
      font-size: 36px;
      font-weight: bold;
      color: #ce0801;
      line-height: 45px;
      text-align: center;
      // white-space: nowrap;
      // overflow: hidden;
      // text-overflow: ellipsis;
      margin-bottom: 0 !important;
    }
    p {
      font-size: 18px;
      color: #333333;
      line-height: 28px;
    }
    i {
      display: inline-block;
      font-style: normal;
      color: #bb2c1b;
      cursor: pointer;
    }
  }
  .top {
    display: flex;
    justify-content: space-between;
    .tit {
      color: #e40000;
      font-size: 30px;
      font-weight: bold;
      border-left: 8px solid #e40000;
      padding-left: 17px;
      margin: 50px 0 45px 25px;
    }
    & > .news {
      margin-left: 25px;
      box-sizing: border-box;
      padding-right: 20px;
      flex: 1;
      overflow: hidden;
      .title {
        // background: url('../assets/images/tips.png') no-repeat 0 center;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: border-box;
        // padding: 0 0 0 20px;
        border-bottom: 1px solid #ccc;
        span {
          font-size: 28px;
          font-weight: bold;
          color: rgb(64, 81, 161);
          // line-height: 16px;
          padding: 0 20px 0;
          border-bottom: 2px solid rgb(64, 81, 161);
        }
        i {
          font-size: 15px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #333333;
          line-height: 30px;
          font-style: normal;
          cursor: pointer;
        }
      }
      ul {
        margin-top: 10px;
        li {
          // background: url('../assets/images/tips2.png') no-repeat 0 center;
          font-size: 20px;
          color: rgb(64, 81, 161);
          line-height: 25px;
          box-sizing: border-box;
          padding: 15px 0 15px 20px;
          // margin: 16px  0;
          cursor: pointer;
          // border-bottom: 1px dashed #ddd;
          position: relative;
          span {
            width: 7px;
            height: 7px;

            background-color: rgb(225, 242, 254);
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 0px;
            transform: rotate(45deg) translateY(-50%);
            // transform: rotate(45deg);
            // border-right: 20px solid blue;
            // border-top: 20px solid yellow;
            // border-left: 20px solid pink;
            // border-bottom: 20px solid red;
          }
          div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .picture-video {
    margin: 15px auto 50px;
    display: flex;
    justify-content: space-between;
    .picture {
      width: 600px;
      .no-content {
        height: 235px;
        border: 1px solid #eee;
        box-sizing: border-box;
      }
      ul {
        width: 600px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        li {
          width: 292.5px;
          overflow: hidden;
          position: relative;
          img {
            width: 100%;
            height: 235px;
          }
          p {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            margin: 0;
            line-height: 37px;
            background: rgba(0, 0, 0, 0.6);
            box-sizing: border-box;
            padding: 0 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 18px;
            font-family: Verdana;
            color: #fff;
            cursor: pointer;
          }
          &:nth-child(1) {
            margin-right: 15px;
          }
        }
      }
    }
    .video {
      margin-left: 25px;
      box-sizing: border-box;
      padding-right: 20px;
      flex: 1;
      overflow: hidden;
      margin-top: -50px;
      .title {
        // background: url('../assets/images/tips.png') no-repeat 0 center;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: border-box;
        // padding: 0 0 0 20px;
        border-bottom: 1px solid #ccc;
        margin-bottom: 20px;
        span {
          font-size: 28px;
          font-weight: bold;
          color: rgb(64, 81, 161);
          // line-height: 16px;
          padding: 0 20px 0;
          border-bottom: 2px solid rgb(64, 81, 161);
        }
        i {
          font-size: 15px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #333333;
          line-height: 30px;
          font-style: normal;
          cursor: pointer;
        }
      }
      ul {
        height: 235px;
        li {
          position: relative;
          img {
            display: block;
            width: 100%;
            height: 235px;
          }
          p {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            margin: 0;
            line-height: 37px;
            background: rgba(0, 0, 0, 0.6);
            box-sizing: border-box;
            padding: 0 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 18px;
            font-family: Verdana;
            color: #fff;
            cursor: pointer;
          }
        }
      }
    }
  }
  .conference {
    .title {
      margin: 0 auto 30px;
      img {
        display: block;
        width: auto;
        max-width: 100%;
        height: auto;
        margin: 0 auto;
      }
    }
    .row {
      display: flex;
      justify-content: space-between;
      .left {
        width: 600px;
        height: 415px;
        .no-content {
          width: 600px;
          height: 415px;
          box-sizing: border-box;
          border: 1px solid #eee;
        }
        & > div {
          position: relative;
        }
        img {
          display: block;
          width: 100%;
          height: 415px;
        }
        p {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          margin: 0;
          line-height: 37px;
          background: rgba(0, 0, 0, 0.6);
          box-sizing: border-box;
          padding: 0 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 18px;
          font-family: Verdana;
          color: #fff;
          cursor: pointer;
        }
      }
      .right {
        box-sizing: border-box;
        padding-right: 20px;
        flex: 1;
        overflow: hidden;
        &:nth-child(2) {
          margin-left: 45px;
        }
        .no-content {
          width: 100%;
          height: 415px;
          box-sizing: border-box;
          border: 1px solid #eee;
        }
        ul {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-flow: row wrap;
          li {
            &:nth-child(odd) {
              width: 50%;
            }
            &:nth-child(even) {
              width: calc(50% - 35px);
            }
            div {
              background: url("../assets/images/tips2.png") no-repeat 0 center;
              font-size: 20px;
              color: #333;
              line-height: 25px;
              box-sizing: border-box;
              padding: 15px 0 15px 15px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              cursor: pointer;
              border-bottom: 1px dashed #ddd;
            }
          }
        }
      }
    }
  }
  .photo-gallery {
    .threeImg .containt {
      position: relative;
      overflow-y: auto;
      width: 1200px;
      height: 165px;
      overflow: hidden;
      margin: 30px auto 10px;
      ul {
        margin: 0 auto;
        width: 2000px;
        position: absolute;
        left: 0px;
        height: 100%;
        z-index: 10;
        li {
          float: left;
          width: 240px;
          height: 165px;
          margin-right: 50px;
          overflow: hidden;
          cursor: pointer;
          img {
            width: 100%;
            height: 135px;
          }
          p {
            display: block;
            width: 100%;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            color: #3273dc;
            font-size: 16px;
            cursor: pointer;
            line-height: 40px;
          }
        }
      }
    }
  }
  .links {
    .tit {
      // margin: 50px auto 30px;
      img {
        display: block;
        width: auto;
        max-width: 100%;
        height: auto;
        margin: 0 auto;
      }
    }
    ul li {
      width: 125px;
      // width: 190px;
      margin: 0 4px 15px;
      cursor: pointer;
      img {
        display: block;
        margin: 0 auto;
        width: 100%;
        height: 40px;
        border: 1px solid #eee;
      }
    }
  }
}
</style>
